import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderSupported extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/supported/order`)
  }

  carTypeList(filter, showProgress) {
    return this._request({
      action: 'carType/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  carCategoryList(filter, showProgress) {
    return this._request({
      action: 'carCategory/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  itemGroupList(filter, showProgress) {
    return this._request({
      action: 'itemGroup/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  itemTypeList(filter, showProgress) {
    return this._request({
      action: 'itemType/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  packageList(filter, showProgress) {
    return this._request({
      action: 'packageType/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  updateCourierSupport(model, showProgress) {
    return this._request({
      action: 'courier',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateDriverSupport(model, showProgress) {
    return this._request({
      action: 'driver',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  poiCategoryList(filter, showProgress) {
    return this._request({
      action: 'poiCategory/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  poiList(filter, showProgress) {
    return this._request({
      action: 'poi/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  get(filter, showProgress) {
    return this._request({
      action: 'get',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  carLoadList(filter, showProgress) {
    return this._request({
      action: 'carLoad/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  loadList(filter, showProgress) {
    return this._request({
      action: 'load/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  employeeList(filter, showProgress) {
    return this._request({
      action: 'employee/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  addonList(filter, showProgress) {
    return this._request({
      action: 'addon/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  loadCondition(filter, showProgress) {
    return this._request({
      action: 'loadCondition/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
